export default __webpack_public_path__ + "static/media/chevrolet.d4ab6331.svg";